<template>
  <div class="col s12 m6">
    <div>
      <div class="page-subtitle">
        <h4>{{'Create' | localize}}</h4>
      </div>

      <form @submit.prevent="submitHandler">
        <div class="input-field">
          <input
            id="name"
            type="text"
            v-model="title"
            :class="{ invalid: $v.title.$dirty && !$v.title.required }"
          />
          <label for="name">{{'Name' | localize}}</label>
          <span
            v-if="$v.title.$dirty && !$v.title.required"
            class="helper-text invalid"
            >{{'MESSAGE_Category_Name' | localize}}</span
          >
        </div>
        <p>{{info.currency | localize}}</p>
        <div class="input-field">
          <input
            id="limit"
            type="number"
            v-model.number="limit"
            :class="{ invalid: $v.limit.$dirty && !$v.limit.minValue && !$v.limit.required}"
          />
          <label for="limit">{{'Limit' | localize}}</label>
          <span
            class="helper-text invalid"
            v-if="$v.limit.$dirty && !$v.limit.minValue || $v.limit.$dirty && !$v.limit.required" 
          >
            {{'MinVal' | localize}} {{ $v.limit.$params.minValue.min }}
          </span>
        </div>

        <button class="btn waves-effect waves-light" type="submit">
          {{'Create' | localize}}
          <i class="material-icons right">send</i>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { required, minValue } from "vuelidate/lib/validators";
import localizeFilter from '@/filters/localize.filter'
import { mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["info"])
  },
  data: () => ({
    title: "",
    limit: 100,
  }),
  validations: {
    title: { required },
    limit: { minValue: minValue(100) , required},
  },
  mounted() {
    M.updateTextFields();
  },
  methods: {
    ...mapActions(["createCategory"]),
    async submitHandler() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }

      try {
        const category = await this.createCategory({
          title: this.title,
          limit: this.limit,
        });
        this.title = "";
        this.limit = 100;
        this.$v.$reset();
        this.$message(localizeFilter('CategoryCreated'))
        this.$emit('created', category)
      } catch (e) {}
    },

  },
};
</script>

<style>
</style>